import React, { useContext } from 'react';
import UserPrefsContext from '../../context/UserPrefs/UserPrefsContext';
import { FormattedMessage, useIntl } from 'react-intl';
import Select, { components } from 'react-select';
import arrowIcon from '../../client_customizations/assets/images/icons/arrow_drop_down_icon.svg';

const DropdownIndicator = (props) => {
  const { selectProps } = props;
  const isOpen = selectProps.menuIsOpen;
  return (
    <components.DropdownIndicator {...props}>
      <img
        src={arrowIcon}
        alt="dropdown arrow"
        style={{
          width: '26px',
          height: '26px',
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
        }}
      />
    </components.DropdownIndicator>
  );
};

const customColors = {
  primary: '#ed3c06',
}

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? `1px solid ${customColors.primary}` : '1px solid #ccc',
    boxShadow: state.isFocused ? `0 0 0 1px ${customColors.primary}` : 'none',
    borderColor: state.isFocused ? customColors.primary : '#ccc',
    background: 'white',
    backgroundImage: 'none',
    fontFamily: "'Lato', sans-serif",
    borderRadius: 0,
    fontSize: '16px',
    minWidth: '160px',
    '&:hover': {
      borderColor: state.isFocused ? customColors.primary : 'black',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'rgba(241, 92, 34, 0.08)'
      : state.isFocused
      ? '#f5f5f5'
      : 'white',
    color: 'black',
    fontFamily: "'Lato', sans-serif",
    fontSize: '16px',
    fontWeight: '400',
    padding: '6px 16px',
    lineHeight: 1.125,
  }),
};

const EvSortControls = ({ inventory, mobile }) => {
  const intl = useIntl();
  const userPrefs = useContext(UserPrefsContext);
  const updateSort = (value) => {
    let newPrefs = {
      vehicleSortType: value.split('-')[0],
      vehicleSortDirection: value.split('-')[1],
    };
    userPrefs.set(newPrefs);
  };

  let sortOptionValue = [
    userPrefs.get('vehicleSortType'),
    userPrefs.get('vehicleSortDirection'),
  ].join('-');

  const options = [
    {
      value: 'electric_range-desc',
      label: intl.formatMessage
        ? intl.formatMessage({
            id: 'evSort.electricRange',
            defaultMessage: 'Electric Range',
          })
        : 'Electric Range',
    },
    {
      value: 'price-asc',
      label: intl.formatMessage
        ? intl.formatMessage({
            id: 'evSort.priceLtH',
            defaultMessage: 'Price: Low to High',
          })
        : 'Price: Low to High',
    },
    {
      value: 'price-desc',
      label: intl.formatMessage
        ? intl.formatMessage({
            id: 'evSort.priceHtL',
            defaultMessage: 'Price: High to Low',
          })
        : 'Price: High to Low',
    },
    {
      value: 'alphabetical-asc',
      label: intl.formatMessage
        ? intl.formatMessage({
            id: 'evSort.alphabeticaldesc',
            defaultMessage: 'Alphabetical: A to Z',
          })
        : 'Alphabetical: A to Z',
    },
    {
      value: 'alphabetical-desc',
      label: intl.formatMessage
        ? intl.formatMessage({
            id: 'evSort.alphabeticalasc',
            defaultMessage: 'Alphabetical: Z to A',
          })
        : 'Alphabetical: Z to A',
    },
    {
      value: 'charge-asc',
      label: intl.formatMessage
        ? intl.formatMessage({
            id: 'evSort.chargeasc',
            defaultMessage: 'Charge speed',
          })
        : 'Charge speed',
    },
  ];

  return (
    <div className="EVsSort">
      <form className="form-inline">
        <label
          htmlFor="vehicle-sort-dropdown"
          className="mr-2"
          style={
            mobile
              ? { fontWeight: '400', marginBottom: '5px' }
              : { marginBottom: '5px' }
          }
        >
          <FormattedMessage
            id="evSort.title"
            defaultMessage="Sort by"
            description="EV Sort By Title"
          />
        </label>
        <Select
          inputId="vehicle-sort-dropdown"
          classNames="form-control"
          id="vehicle-sort-dropdown"
          value={options.find((option) => option.value === sortOptionValue)}
          onChange={(selectedOption) => updateSort(selectedOption.value)}
          options={options}
          isSearchable={false}
          styles={customStyles}
          components={{ DropdownIndicator }}
        />
      </form>
    </div>
  );
};

export default EvSortControls;
